import { TipoSituacaoProcessoJudicial } from "constants/EnumTipoSituacaoProcessoJudicial";
import { mensagemDeErroPadrao } from "shared/util/functions/yup/MensagensDeErroInput";
import { RegistroAcordoDTO } from "types/dto/RegistroAcordoDTO";
import { SelectOptionType } from "types/select/SelectOptionType";
import * as yup from "yup";

export const modalAdicionarProcessoJudicialHistoricoSchema = yup.object().shape({
  data: yup.date()
    .required(mensagemDeErroPadrao("Data"))
    .typeError("Informe uma data válida"),
  situacao: yup
    .mixed<TipoSituacaoProcessoJudicial>().nullable()
    .required(mensagemDeErroPadrao("Situação")),
  anotacoes: yup.string()
    .required(mensagemDeErroPadrao("Anotações")),
  possuiAcordosVinculados: yup.boolean().default(false),
  acordos: yup
    .array()
    .of(yup.mixed<SelectOptionType<RegistroAcordoDTO>>())
    .when(["possuiAcordosVinculados"], ([possuiAcordosVinculados], schema) => {
      if (possuiAcordosVinculados) {
        return schema
          .test("acordos-nulos", mensagemDeErroPadrao("Acordos"), (acordos) => {
            if (acordos) {
              return acordos?.length > 0;
            }
          })
          .required(mensagemDeErroPadrao("Acordos"));
      } else {
        return schema;
      }
    }),
});
